import React from 'react';
import PropTypes, { InferProps } from 'prop-types';
import styled from '@emotion/styled';
import CategoryHeading from '../../CategoryHeading';
import breakpoints from '../../Theme/breakpoints';
import Border from './Border';
import colors from '../../Theme/colors';

export const WfbAdsSectionLoaderWrapper = styled.div`
  border-top: 1px solid ${colors.greyDark};
  padding: 51px 0 0;
`;

const WfbAdsSectionWrapper = styled.div`
  padding: 0;

  @media (min-width: ${breakpoints.md}px) {
    > div > a:nth-of-type(4) {
      display: none;
    }
  }
  @media (min-width: ${breakpoints.lg}px) {
    padding: 24px 0 0;
    border-top: 1px solid ${colors.greyDark};
    > div > a:nth-of-type(4) {
      display: unset;
    }
  }
`;

const WfbAdsHeading = styled(CategoryHeading)`
  && {
    margin-bottom: 24px;

    @media (min-width: ${breakpoints.sm}px) {
      width: 100%;
      margin-bottom: 8px;
      grid-column: 1 / -1;
    }
    @media (min-width: ${breakpoints.md}px) {
      margin-bottom: 8px;
    }
  }
`;

const wfbAdsSectionPropertyTypes = {
  wfbAdsHeader: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

type WfbAdsSectionProperties = InferProps<
  typeof wfbAdsSectionPropertyTypes
>;

const WfbAdsSection = ({
  children, wfbAdsHeader,
}: WfbAdsSectionProperties) => (
  <>
    <Border />
    <WfbAdsSectionWrapper>
      <WfbAdsHeading>
        {wfbAdsHeader}
      </WfbAdsHeading>
      {children}
    </WfbAdsSectionWrapper>
  </>
);

WfbAdsSection.propTypes = wfbAdsSectionPropertyTypes;

export default WfbAdsSection;
